import { Component } from '@angular/core'
import { pointSettingListModel } from '../../models/pointing-system.models'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { PointingSystemService } from '../../services/pointing-system.service'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ToastrService } from 'ngx-toastr'

@Component({
	selector: 'app-customize-points',
	templateUrl: './customize-points.component.html',
	styleUrl: './customize-points.component.scss',
})
export class CustomizePointsComponent {
	countryId: number = 224
	pointingSettings!: pointSettingListModel[]
	generalValuesArray: pointSettingListModel[] = []
	marketPlaceValuesArray: pointSettingListModel[] = []
	salonValuesArray: pointSettingListModel[] = []
	settingValuesArray: any[] = []
	mainForm: FormGroup = new FormGroup({})
	expiryDaysCount: number = 0
	pointCost: number = 0
	constructor(
		public translate: TranslateService,
		private PointingSystemService: PointingSystemService,
		private SharedService: SharedService,
		private toaster: ToastrService
	) {
		this.mainForm = new FormGroup({})
		this.SharedService.headerTitle.next(
			`POINTING_SYSTEM.CUSTOMIZING_POINTS.PAGE_TITLE`
		)
		this.SharedService.handleBreadCrumb('pointing-system', true, {
			url: '/layout/pointing-system',
		})
		this.getPointingSettings()
		this.createSettingsFormControls()
	}
	initForm() {
		this.mainForm = new FormGroup(
			this.pointingSettings.reduce(
				(acc: { [key: string]: FormGroup }, section: pointSettingListModel) => {
					acc[this.removeSpaces(section.name.en)] = new FormGroup({})
					return acc
				},
				{}
			)
		)
		this.mainForm.addControl(
			'expiryDaysCount',
			new FormControl(this.expiryDaysCount, [Validators.min(0)])
		)
		this.mainForm.addControl(
			'pointCost',
			new FormControl(this.pointCost, [Validators.min(0)])
		)
	}
	changeCountry(event: any) {
		this.generalValuesArray = []
		this.marketPlaceValuesArray = []
		this.salonValuesArray = []
		this.settingValuesArray = []
		this.countryId = event
		this.getPointingSettings()
	}
	getPointingSettings() {
		this.PointingSystemService.getPointingSystemSettings(
			this.countryId
		).subscribe({
			next: (res: any) => {
				this.pointingSettings = res.result.pointSettingList
				this.pointCost = res.result.pointCost
				this.expiryDaysCount = res.result.expiryDaysCount
				this.settingValuesArray = Object.keys(res.result)

				this.settingValuesArray.splice(
					this.settingValuesArray.indexOf('pointSettingList'),
					1
				)
				this.initForm()
				this.createSettingsFormControls()
				this.createFormControls()
			},
			complete: () => {},
		})
	}
	createFormControls() {
		this.pointingSettings.forEach((ele) => {
			switch (ele.checkOutModule) {
				case 1:
					this.generalValuesArray.push(ele)
					break

				case 2:
					this.marketPlaceValuesArray.push(ele)
					break
				case 3:
					this.salonValuesArray.push(ele)
					break

				default:
					break
			}
			let nestedGroup = this.mainForm.get(
				this.removeSpaces(ele.name.en)
			) as FormGroup

			nestedGroup?.addControl(
				`id`,
				new FormControl(ele.id, [Validators.required, Validators.min(1)])
			)
			if (ele.checkOutModule != 1) {
				nestedGroup?.addControl(
					`limitPerDay`,
					new FormControl(ele.limitPerDay, [Validators.min(1)])
				)
			}
			nestedGroup?.addControl(
				`points`,
				new FormControl(ele.points, [
					Validators.required,
					Validators.min(0.001),
				])
			)
			nestedGroup?.addControl(
				`isActive`,
				new FormControl(ele.isActive, [Validators.required, Validators.min(1)])
			)
		})
		this.createSettingsFormControls()
	}
	createSettingsFormControls() {
		this.settingValuesArray.forEach((ele) => {
			this.mainForm?.addControl(
				ele,
				new FormControl(ele, [Validators.required, Validators.min(2)])
			)
		})
	}
	getSubController(formGroupName: string, controllerName: string) {
		let formGroup = this.mainForm.controls[formGroupName] as FormGroup
		return formGroup.controls[controllerName]
	}
	keypressValidation(event: any, itemName: String | null = null) {
		console.log(itemName, 'item name')

		return !itemName
			? event.charCode == 8 || event.charCode == 0 || event.charCode == 13
				? null
				: event.charCode >= 48 && event.charCode <= 57
			: null
	}
	removeSpaces(str: any) {
		return str ? str?.replace(/\s+/g, '') : null
	}
	updatePointingSettings(body: any) {
		this.PointingSystemService.updatePointsSettings(body).subscribe({
			complete: () => {
				this.generalValuesArray = []
				this.marketPlaceValuesArray = []
				this.salonValuesArray = []
				this.settingValuesArray = []
				this.getPointingSettings()
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
			},
		})
	}
	getController(controlName: string) {
		return this.mainForm.controls[controlName] as FormControl
	}
	submit() {
		let formValues = this.mainForm.getRawValue()
		delete formValues.pointCost
		delete formValues.expiryDaysCount
		let keysArray = Object.keys(formValues)
		let valuesArray: any[] = []
		keysArray.forEach((ele: any) => {
			valuesArray.push(this.mainForm.getRawValue()[ele])
		})
		let body = {
			updatePointSetting: valuesArray,
			countryId: this.countryId,
			pointCost: this.getController('pointCost').value,
			expiryDaysCount: this.getController('expiryDaysCount').value,
		}
		this.updatePointingSettings(body)
	}
	logger() {
		console.log(this.mainForm.controls)
	}
}
